import React from 'react';
import { isFormEditable } from './dataHelpersNew';
import { DynamicUiContext, DynamicUiContextType } from './DynamicUiContext';

export function DynamicUiProviderNew({
  children,
  form,
  uiData,
  items,
  isEditing,
  isCreateMode,
  setIsEditing,
  isDeletable,
  onDelete,
  renderUiEntityTitle,
  clientId,
}: DynamicUiContextType & {
  children: React.ReactNode;
}) {
  const renderedItems = items ?? uiData.ui.layout;
  const value = {
    form,
    uiData,
    isEditing,
    setIsEditing,
    isCreateMode,
    isDeletable,
    onDelete,
    renderUiEntityTitle,
    clientId,
    toggleEditing: () => {
      if (isEditing) {
        form.reset();
      }
      setIsEditing(!isEditing);
    },
    items,
    isEditable: isFormEditable(form, renderedItems, uiData),
  };

  return <DynamicUiContext.Provider value={value}>{children}</DynamicUiContext.Provider>;
}
